'use strict';

module.exports = function () {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var defaultProtocol = location && location.protocol || 'https';
    var _url = '';
    if (/^(\/){2}/.test(url)) {
        _url = defaultProtocol + url;
    } else {
        _url = url;
    }
    return _url;
};


//////////////////
// WEBPACK FOOTER
// ../src/util/protocol.js
// module id = 17
// module chunks = 0 2 4